import PageContainer from '@/common/components/PageContainer'
import CreatePartnerListing from '@/modules/manage-player/components/CreatePartner/CreatePartnerListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function CreatePartnerPage() {
	return (
		<PageContainer>
			<CreatePartnerListing />
		</PageContainer>
	)
}

const GuardedCreatePartnerPage = withUserPermission(CreatePartnerPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedCreatePartnerPage
